import { connect } from 'react-redux';

import { actionCreators } from 'dux/instances';
import CADownloadLink from './CADownloadLink';

const mapDispatchToProps = {
  getInstanceCertificateDownload: actionCreators.getInstanceCertificateDownload,
};

export default connect(null, mapDispatchToProps)(CADownloadLink);
